<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 200 200"
    style="enable-background: new 0 0 200 200"
    xml:space="preserve"
  >
    <rect x="0.2" y="0.2" style="fill: #017acb" width="200" height="200" />
    <g>
      <path
        style="fill: #fbfcfd"
        d="M101.9,114.7c3-1.7,5.6-3.4,8.6-5.1c2.1,3,4.3,5.6,8.1,6c1.7,0,3.8,0,5.6-0.9
		c3.4-1.3,3.8-5.6,0.9-7.7c-2.1-1.3-4.7-2.6-7.3-3.8c-2.1-1.3-4.3-2.1-6.4-3.4c-5.1-3.4-7.3-9.4-5.6-15.4c1.3-5.1,6.4-9,12.4-9.4
		c7.3-0.4,12.4,2.1,15.8,8.1c-2.6,1.7-4.7,3.4-7.7,5.1c-1.7-2.6-3.4-4.3-6.4-4.3c-2.1,0-3.8,0.9-4.3,3c-0.4,2.1,0,3.8,2.1,5.1
		s4.7,2.1,6.8,3.4c1.7,0.9,3.8,1.7,5.6,3c5.6,3.4,8.1,8.6,7.3,14.5c-1.3,6.4-5.6,9.8-11.5,11.1c-6.8,1.7-13.3,0.9-18.8-3.8
		C105.3,119,103.6,116.9,101.9,114.7z"
      />
      <path
        style="fill: #f9fbfd"
        d="M99.8,76.2c0,3,0,5.6,0,8.6c-4.7,0-9,0-13.7,0c0,13.3,0,26.5,0,39.3c-3.4,0-6.4,0-9.8,0
		c0-13.3,0-26.1,0-39.3c-4.7,0-9.4,0-13.7,0c0-3,0-5.6,0-8.6C75,76.2,87.4,76.2,99.8,76.2z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "IconTs",
};
</script>
